import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Wrench, AlertOctagon, Unplug } from "lucide-react";
import Classification from "@/components/Classification";

export default function Technician() {
  const [procs, setProcs] = useState([]);
  useEffect(() => { api.get("/content/techprocedures").then((r) => setProcs(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-6" data-testid="technician-page">
      {/* Warning banner */}
      <div className="rounded-2xl border-2 border-red-500 bg-red-50 p-6" data-testid="technician-warning">
        <div className="flex items-center gap-3 text-red-700">
          <AlertOctagon className="w-9 h-9 shrink-0" />
          <div>
            <h1 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight">TECHNICIAN / TRAINED INTERNAL STAFF ONLY</h1>
            <p className="text-red-800 mt-1 text-sm">
              These replacement steps are for approved technician, warehouse or trained internal staff only. They are not normal customer troubleshooting.
            </p>
          </div>
        </div>
        <div className="mt-4 flex items-center gap-2 text-sm text-red-800 bg-white/70 border border-red-200 rounded-lg px-3 py-2">
          <Unplug className="w-4 h-4" /> Unplug the adjustable bed from power before removing or replacing any part. Confirm troubleshooting was attempted and approved.
        </div>
      </div>

      <div className="space-y-4">
        {procs.map((p) => (
          <Card key={p.id} className="p-6 border-l-4 border-l-red-500" data-testid={`techproc-${p.id}`}>
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-lg bg-red-500 text-white flex items-center justify-center"><Wrench className="w-5 h-5" /></div>
                <h3 className="font-heading font-bold text-slate-900 text-lg">{p.title}</h3>
              </div>
              <Classification value={p.classification} />
            </div>
            {p.warning && (
              <div className="mt-3 text-sm text-red-800 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{p.warning}</div>
            )}
            <ol className="mt-4 space-y-2">
              {(p.steps || []).map((s, i) => (
                <li key={i} className="flex gap-3 text-sm text-slate-700">
                  <span className="w-6 h-6 rounded-full bg-slate-900 text-white text-xs font-bold flex items-center justify-center shrink-0">{i + 1}</span>
                  <span>{s}</span>
                </li>
              ))}
            </ol>
            <div className="text-xs text-slate-400 mt-4">Source: {p.source} · v{p.version} · reviewed {p.last_reviewed}</div>
          </Card>
        ))}
        {procs.length === 0 && <p className="text-slate-400">No technician procedures yet.</p>}
      </div>
    </div>
  );
}
